export default function Footer() {
    return (
        <footer className="py-3">
            <div className="small text-center text-muted">2022 BITWA O ŚLĄSK. Wszystkie prawa zastrzeżone.</div>
        </footer>
    );
}